import { useEffect, useState } from "react";
import api, { BACKEND } from "../api";

const COLORI = { "Pubblicato": "#22c55e", "Bozza da pubblicare": "#f59e0b", "Nessuna bozza": "#64748b" };

export default function Cruscotti() {
  const [lista, setLista] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [nuovoCliente, setNuovoCliente] = useState("");
  const [sel, setSel] = useState(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");
  const [visite, setVisite] = useState(null);

  const load = () => api.get("/cruscotti").then((r) => setLista(r.data)).catch(() => {});
  useEffect(() => {
    load();
    api.get("/companies").then((r) => setCompanies(r.data)).catch(() => {});
  }, []);

  const apri = async (c) => {
    const r = await api.get(`/cruscotti/${c.id}`);
    setSel(r.data); setFile(null); setMsg("");
    api.get(`/cruscotti/${c.id}/visite`).then((v) => setVisite(v.data)).catch(() => setVisite(null));
  };

  const crea = async () => {
    if (!nuovoCliente) return;
    setBusy("crea"); setMsg("");
    try {
      const r = await api.post("/cruscotti", { cliente_id: nuovoCliente });
      setNuovoCliente(""); await load(); await apri(r.data);
    } catch (e) { setMsg(e.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };

  const caricaBozza = async () => {
    if (!file || !sel) { setMsg("Scegli prima un file .html"); return; }
    setBusy("bozza"); setMsg("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/cruscotti/${sel.id}/bozza`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setSel(r.data); setFile(null); setMsg("Bozza caricata: la versione pubblica non è cambiata.");
      document.getElementById("cruscotto-file").value = "";
      await load();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(""); }
  };

  const anteprima = () => {
    if (!sel?.anteprima_token) return;
    window.open(`${BACKEND}/api/cruscotti/anteprima/${sel.codice}/${sel.anteprima_token}`, "_blank", "noopener");
  };

  const pubblica = async () => {
    if (!window.confirm("Pubblicare la bozza? Da subito il cliente vedrà questa versione.")) return;
    setBusy("pubblica"); setMsg("");
    try {
      const r = await api.post(`/cruscotti/${sel.id}/pubblica`);
      setSel(r.data); setMsg("Pubblicato: il link del cliente mostra la nuova versione.");
      await load();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(""); }
  };

  const copiaLink = async () => {
    const url = `${window.location.origin}/cruscotto/${sel.codice}`;
    try { await navigator.clipboard.writeText(url); setMsg(`Link copiato: ${url}`); }
    catch { window.prompt("Copia il link:", url); }
  };

  const salvaPeriodo = async (periodo) => {
    const r = await api.patch(`/cruscotti/${sel.id}`, { periodo });
    setSel(r.data); await load();
  };

  const ripristina = async (v) => {
    if (!window.confirm(`Ripubblicare la versione del ${new Date(v.pubblicato_il).toLocaleDateString("it-IT")}?`)) return;
    const r = await api.post(`/cruscotti/${sel.id}/ripristina/${v.id}`);
    setSel(r.data); setMsg("Versione ripristinata."); await load();
  };

  return (
    <div>
      <div className="toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
        <h2 style={{ margin: 0 }}>Cruscotti</h2>
        <div className="spacer" />
        <select value={nuovoCliente} onChange={(e) => setNuovoCliente(e.target.value)} style={{ maxWidth: 280 }} data-testid="cruscotto-nuovo-cliente">
          <option value="">Nuovo cruscotto: scegli il cliente…</option>
          {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <button className="btn sm primary" onClick={crea} disabled={!nuovoCliente || busy === "crea"} data-testid="cruscotto-crea">+ Nuovo cruscotto</button>
      </div>

      <div className="panel" style={{ marginTop: 12 }}>
        <table data-testid="cruscotti-table">
          <thead><tr><th>Cliente</th><th>Codice</th><th>Stato</th><th>Periodo</th><th>Ultimo aggiornamento</th><th>Pubblicato il</th><th>Aperture</th></tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={7} className="muted">Nessun cruscotto: creane uno scegliendo il cliente qui sopra.</td></tr>}
            {lista.map((c) => (
              <tr key={c.id} onClick={() => apri(c)} style={{ cursor: "pointer", background: sel?.id === c.id ? "rgba(56,189,248,.08)" : undefined }} data-testid={`cruscotto-row-${c.codice}`}>
                <td><strong>{c.cliente}</strong></td>
                <td className="muted" style={{ fontFamily: "monospace" }}>{c.codice}</td>
                <td><span className="chip" style={{ background: COLORI[c.stato] }}>{c.stato}</span></td>
                <td className="muted">{c.periodo || "—"}</td>
                <td className="muted">{c.bozza_caricata_il ? new Date(c.bozza_caricata_il).toLocaleString("it-IT") : "—"}</td>
                <td className="muted">{c.pubblicato_il ? new Date(c.pubblicato_il).toLocaleString("it-IT") : "—"}</td>
                <td data-testid={`cruscotto-visite-${c.codice}`}>
                  {c.visite > 0
                    ? <><strong>{c.visite}</strong><div className="muted" style={{ fontSize: 11 }}>ultima {new Date(c.ultima_visita).toLocaleString("it-IT")}</div></>
                    : <span className="muted">mai aperto</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {sel && (
        <div className="panel" style={{ marginTop: 16, borderLeft: "4px solid #38bdf8" }} data-testid="cruscotto-dettaglio">
          <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
            <h3 style={{ margin: 0 }}>{sel.cliente}</h3>
            <span className="chip" style={{ background: COLORI[sel.stato] }}>{sel.stato}</span>
            <div className="spacer" />
            <button className="btn sm" id="btn-copia-link" onClick={copiaLink} data-testid="btn-copia-link">🔗 Copia link pubblico</button>
          </div>
          <p className="muted" style={{ marginTop: 4 }}>
            Link fisso del cliente: <code>{window.location.origin}/cruscotto/{sel.codice}</code>
          </p>

          <div className="field" style={{ maxWidth: 360 }}>
            <label>Periodo</label>
            <input defaultValue={sel.periodo} placeholder="es. gennaio – settembre 2026"
              onBlur={(e) => e.target.value !== sel.periodo && salvaPeriodo(e.target.value)}
              data-testid="cruscotto-periodo" />
          </div>

          <div className="toolbar" style={{ gap: 8, flexWrap: "wrap", marginTop: 8 }}>
            <input type="file" id="cruscotto-file" accept=".html,.htm,text/html"
              onChange={(e) => setFile(e.target.files[0] || null)} data-testid="cruscotto-file" />
            <button className="btn sm primary" id="btn-carica-bozza" onClick={caricaBozza} disabled={busy === "bozza"} data-testid="btn-carica-bozza">
              {busy === "bozza" ? "Carico…" : "⬆ Carica bozza"}
            </button>
            <button className="btn sm" id="btn-anteprima" onClick={anteprima} disabled={!sel.bozza_caricata_il} data-testid="btn-anteprima">👁 Anteprima bozza</button>
            <button className="btn sm" id="btn-pubblica" onClick={pubblica} disabled={!sel.bozza_caricata_il || busy === "pubblica"} data-testid="btn-pubblica">
              {busy === "pubblica" ? "Pubblico…" : "🚀 Pubblica"}
            </button>
          </div>
          {msg && <p className="muted" data-testid="cruscotto-msg" style={{ marginTop: 8 }}>{msg}</p>}

          <div style={{ marginTop: 16 }}>
            <h4 style={{ margin: "0 0 6px" }}>Chi l'ha aperto</h4>
            {!visite || visite.totale === 0 ? (
              <p className="muted" data-testid="cruscotto-visite-vuoto">Nessuna apertura finora: il cliente non ha ancora visto il link.</p>
            ) : (
              <>
                <p className="muted" style={{ marginTop: 0 }} data-testid="cruscotto-visite-riassunto">
                  <strong>{visite.totale}</strong> aperture in tutto · <strong>{visite.dopo_ultima_pubblicazione}</strong> dopo l'ultima pubblicazione
                </p>
                <table data-testid="cruscotto-visite-tabella">
                  <thead><tr><th>Quando</th><th>Da dove</th><th>Rete</th></tr></thead>
                  <tbody>
                    {visite.elenco.slice(0, 25).map((v, i) => (
                      <tr key={i}>
                        <td>{new Date(v.quando).toLocaleString("it-IT")}</td>
                        <td className="muted">{v.dispositivo}</td>
                        <td className="muted">{v.ip}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p className="muted" style={{ fontSize: 12 }}>Le anteprime generate da WhatsApp e dai motori di ricerca non vengono contate, e le riletture entro mezz'ora valgono come una sola apertura.</p>
              </>
            )}
          </div>

          <div style={{ marginTop: 16 }}>
            <h4 style={{ margin: "0 0 6px" }}>Versioni pubblicate</h4>
            {(!sel.storico || sel.storico.length === 0) ? (
              <p className="muted" data-testid="cruscotto-storico-vuoto">Nessuna versione precedente.</p>
            ) : (
              <table data-testid="cruscotto-storico">
                <thead><tr><th>Pubblicata il</th><th>Periodo</th><th></th></tr></thead>
                <tbody>
                  {sel.storico.map((v) => (
                    <tr key={v.id}>
                      <td className="muted">{new Date(v.pubblicato_il).toLocaleString("it-IT")}</td>
                      <td className="muted">{v.periodo || "—"}</td>
                      <td><button className="btn sm" onClick={() => ripristina(v)} data-testid={`cruscotto-ripristina-${v.id}`}>↩ Ripristina</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
